(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/draws/assets/javascripts/helpers/draw-include.js') >= 0) return;  svs.modules.push('/components/marketplace-data/draws/assets/javascripts/helpers/draw-include.js');
"use strict";


const _drawIncludes = ['drawNumber', 'regCloseTime', 'productId', 'drawComment', 'description', 'drawState', 'drawStateId', 'currentNetSale', 'currentNetSales', 'userProduct', 'productName'];
const _drawEventIncludes = ['drawEvents.eventTypeId', 'drawEvents.eventNumber', 'drawEvents.eventDescription', 'drawEvents.eventComment', 'drawEvents.outcomes.outcomeNumber', 'drawEvents.outcomes.description', 'drawEvents.participantType', 'drawEvents.match.participants.h2HName', 'drawEvents.match.participants.mediumName', 'drawEvents.match.matchStart', 'events.eventNumber', 'events.eventDescription', 'events.outcomes.outcomeNumber', 'events.outcomes.description', 'events.match.matchStart'];
const getIncludes = _ref => {
  let {
    excludeEvents = false
  } = _ref;
  return excludeEvents ? _drawIncludes : [..._drawIncludes, ..._drawEventIncludes];
};
const drawInclude = function (parent) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return getIncludes(options).map(include => "".concat(parent, ".").concat(include)).join(',');
};
setGlobal('svs.components.marketplaceData.draws.helpers.drawInclude', drawInclude);

 })(window);